<div class="modal-header justify-content-start">
    <h4 class="modal-title text-danger" id="exampleModalLabel">
      {{ title }}
    </h4>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="closeModal()"
    ></button>
  </div>
  <div class="modal-body" class="p-3">
    <span>{{ description }}</span>
  </div>
  
  <div class="modal-footer">
    <button class="btn btn-outline-primary" (click)="closeModal()">
      {{ cancelText }}
    </button>
    <button class="btn btn-primary m-r-20" [disabled]="isLoading || remainingTime > 0" (click)="confirm()">
      <loading-button
        [loading]="isLoading"
        [value]="confirmButtonText()"
        [icon]="null"
      >
      </loading-button>
    </button>
  </div>
  